import { render, staticRenderFns } from "./ChangeUserPwd.vue?vue&type=template&id=b46d0766&scoped=true"
import script from "./ChangeUserPwd.vue?vue&type=script&lang=ts"
export * from "./ChangeUserPwd.vue?vue&type=script&lang=ts"
import style0 from "./ChangeUserPwd.vue?vue&type=style&index=0&id=b46d0766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46d0766",
  null
  
)

export default component.exports